import { useMemo } from 'react';
import type { WorkspaceSummary } from '../../../../music24-api/src/app/components/Workspaces/listUserWorkspaces';
import { useUserTokenDecoded } from '../../redux/slices/appInfo/hooks';
import { useTRPCAPI, useTRPCQuery } from '../../trpc/trpc';
import type { ErrorAPIResult } from '../../redux/api/utils/isSuccessfulResult';

/** One row of `workspaces.list`. */
export type { WorkspaceSummary };

export interface WorkspacesState {
  workspaces: WorkspaceSummary[];
  active: WorkspaceSummary | null;
  isLoading: boolean;
  /** The `workspaces.list` error, for `ErrorView`. Null while the list loads or after it loaded. */
  error: ErrorAPIResult['error'] | null;
  refetch: () => Promise<unknown>;
}

/** Every workspace of the signed-in user (`workspaces.list`): the home workspace first, then by name. */
export function useWorkspaces(): WorkspacesState {
  const trpcAPI = useTRPCAPI();
  const isSignedIn = useUserTokenDecoded() !== null;
  const query = useTRPCQuery(
    trpcAPI.workspaces.list.queryOptions(undefined, { enabled: isSignedIn, retry: false, staleTime: 60 * 1000 })
  );
  const workspaces = useMemo(() => query.data ?? [], [query.data]);
  const active = useMemo(() => workspaces.find((workspace) => workspace.isActive) ?? null, [workspaces]);
  return { workspaces, active, isLoading: query.isLoading, error: query.error, refetch: query.refetch };
}
